<div class="company-header" *ngIf="hasIndustryCompany()">
  <div class="company-card">
    <div class="company-logo">
      <img src="./assets/icons/no-logo-company-icon.svg" />
    </div>

    <div class="company-data">
      <div class="company-name">
        {{ getIndustryCompany().getTradingName() }}
      </div>
      <span class="company-cnpj">
        CNPJ:
        {{ getIndustryCompany().getFiscalNumber() | companyFederalNumber }}
      </span>
    </div>
  </div>
</div>

<div class="table-header-lpm">
  <div class="search-container" pattern="[0-9]+">
    <div>
      <span><b>Busca por EAN</b></span>
      <input [(ngModel)]="ean" type="text" autofocus (keyup.enter)="searchProductsByEan()" />
    </div>

    <div class="icon-container" (click)="searchProductsByEan()">
      <mat-icon aria-hidden="false">search</mat-icon>
    </div>
  </div>

  <div>
    <button class="add-lpm-product" mat-flat-button (click)="addLpmProduct()">ADICIONAR PRODUTO</button>
  </div>
</div>

<div>
  <p class="register-count" *ngIf="!hasIndustryProductDiscounts()">Não foram encontrados resultados.</p>
  <p class="register-count" *ngIf="hasIndustryProductDiscounts()">
    Foram encontrados
    {{ industryDiscount.getIndustryProductDiscounts().length }} registros
  </p>
</div>

<div class="industry-list-container">
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="ean">
        <th mat-header-cell *matHeaderCellDef>EAN</th>
        <td mat-cell *matCellDef="let item">{{ item.getEan().getValue() }}</td>
      </ng-container>

      <ng-container matColumnDef="userDiscount">
        <th class="align-center" mat-header-cell *matHeaderCellDef>Desconto de Usuário</th>
        <td class="align-center" mat-cell *matCellDef="let item">
          <app-inline-edit [(ngModel)]="item.userDiscount" (changeDataEvent)="onChangeData($event, item.getIndustryProductDiscountKey())"></app-inline-edit>
          <span>%</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="directDiscount">
        <th class="align-center" mat-header-cell *matHeaderCellDef>Desconto Direto</th>
        <td class="align-center" mat-cell *matCellDef="let item">
          <app-inline-edit [(ngModel)]="item.directDiscount" (changeDataEvent)="onChangeData($event, item.getIndustryProductDiscountKey())"></app-inline-edit>
          <span>%</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="indirectDiscount">
        <th class="align-center" mat-header-cell *matHeaderCellDef>Desconto Indireto</th>
        <td class="align-center" mat-cell *matCellDef="let item">
          <app-inline-edit [(ngModel)]="item.indirectDiscount" (changeDataEvent)="onChangeData($event, item.getIndustryProductDiscountKey())"></app-inline-edit>
          <span>%</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="deleteProduct">
        <th class="align-center" mat-header-cell *matHeaderCellDef>Remover</th>
        <td class="align-center" mat-cell *matCellDef="let item">
          <mat-icon class="delete-icon" (click)="onDeleteProduct(item)"> delete </mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 30]"></mat-paginator>
  </div>
</div>
